import { PropsWithChildren, useState, useMemo, useRef } from 'react';

import { HoverMenu, HoverMenuProps } from './HoverMenu';
import { HoverMenuContext, HoverMenuContextState } from './HoverMenu.context';

const isDescendant = (el: Node | null | undefined, parent: Node | null | undefined) => {
  let currentEl: Node | null | undefined = el;

  if (parent && currentEl) {
    if (currentEl === parent) {
      //is this the element itself?
      return true;
    }
    while ((currentEl = currentEl.parentNode)) {
      if (currentEl === parent) {
        return true;
      }
    }
  }

  return false;
};

export const HoverMenuProvider = ({ children }: PropsWithChildren) => {
  const [state, setState] = useState<HoverMenuProps>({ anchorEl: null, open: false });
  const rootRef = useRef<HTMLDivElement | null>(null);

  const value: HoverMenuContextState = useMemo(
    () => ({
      menuClose: () => {
        setState((prev) => ({ ...prev, open: false }));
      },
      menuOpen: (props: Omit<HoverMenuProps, 'open'>) => {
        setState({
          ...props,
          open: true,
        });
      },
      isDescendant: (node) => isDescendant(node, rootRef.current),
    }),
    [],
  );

  return (
    <>
      <HoverMenuContext.Provider value={value}>{children}</HoverMenuContext.Provider>
      <HoverMenu ref={rootRef} onClose={value.menuClose} {...state}>
        {state.children}
      </HoverMenu>
    </>
  );
};
